import { pick } from 'ramda';

import * as zod from 'zod';

export const envSchema = zod.object({
  SERVER_API: zod.string().min(1),
  GRAPHQL_ENDPOINT: zod.string().min(1),
  SUPER_ADMIN_EMAIL: zod.string().min(1),
  PUBLIC_URL_DOWNLOAD: zod.string().min(1),
  DEFAULT_LOCALE: zod.string().min(1),

  PROJECT_TITLE: zod.string().min(1),
  PROJECT_ADDRESS: zod.string().min(1),
  COMPANY_HOTLINE: zod.string().min(1),

  TOLGEE_ENABLED: zod.string().optional(),
  TOLGEE_API_URL: zod.string().optional(),
  TOLGEE_API_KEY: zod.string().optional(),
});

function getPublicKeys() {
  const env = envSchema.parse(process.env);
  return {
    publicKeys: pick(
      [
        'SERVER_API',
        'GRAPHQL_ENDPOINT',
        'DEFAULT_LOCALE',
        'SUPER_ADMIN_EMAIL',
        'PUBLIC_URL_DOWNLOAD',
        'PROJECT_TITLE',
        'PROJECT_ADDRESS',
        'COMPANY_HOTLINE',
        'TOLGEE_ENABLED',
        'TOLGEE_API_URL',
        'TOLGEE_API_KEY',
      ],
      env,
    ),
  };
}

export { getPublicKeys };
